import { Text, textFontStyles } from '@makemydeal/dr-ui-bricks-components';
import styled from 'styled-components';

export const CharacterCount = styled(Text)`
    line-height: 20px;
`;

export const ButtonContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    margin-top: 30px;

    .submit-button {
        width: auto;
        ${textFontStyles('large', 'semibold')}
        padding: 12px 45px;
        border-radius: 4px;
        text-transform: none;
    }

    .cancel-button {
        ${textFontStyles('base', 'semibold')}
        padding: 0;
        text-transform: none;
    }
`;
